import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  actionLabel?: string;
  actionTo?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  eyebrow,
  actionLabel,
  actionTo,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 border-b border-background-200 pb-3">
      <div>
        {eyebrow && (
          <p className="mb-1 text-[11px] font-medium uppercase tracking-[0.2em] text-accent-600">{eyebrow}</p>
        )}
        <h2 className="flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-5 w-1 rounded-full bg-accent-500" aria-hidden="true" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">
        {children}
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
          >
            {actionLabel}
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        )}
      </div>
    </div>
  );
}